export default __webpack_public_path__ + "assets/icons/buttonDownload.90a19dc6.svg";